import { Action } from '@ngrx/store';

export const GET_HOTEL_SUPPLIERS = '[Hotel Meal Basis] Get hotel suppliers';
export const GET_HOTEL_SUPPLIERS_SUCCESS = '[Hotel Meal Basis] Get hotel suppliers success';

export class GetHotelSuppliers implements Action {
  readonly type = GET_HOTEL_SUPPLIERS;
}

export class GetHotelSuppliersSuccess implements Action {
  readonly type = GET_HOTEL_SUPPLIERS_SUCCESS;
  constructor(public payload: { [id: string]: boolean }) {}
}

export type HotelSupplierActions = GetHotelSuppliers | GetHotelSuppliersSuccess;
